import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const ArrowCustomStyle = {
  index: css`
    cursor: pointer;
    pointer-events: visible;
    background: ${theme.colors.gradient[1]};
    transition: all 0.25s ease-in-out;
    opacity: 0.7;
    width: 55px;
    height: 120px;
    svg {
      color: #f0f6ff;
      margin: auto;
      display: block;
      height: 100%;
      width: 60px;
    }
    &:hover {
      transition: all 0.25s ease-in-out;
      background-color: ${theme.colors.darkGreen};
    }
  `,
};
